import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    StyleSheet,
    TouchableOpacity
} from 'react-native';

import {
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib';

import { pt } from '../../common/utils';

export default class MovieCardItem extends PureComponent {
    constructor(props) {
        super(props);

        this.cardClick = this.cardClick.bind(this);
    }

    render() {
        const { cardInfo } = this.props;

        let uri;

        if (cardInfo.canUse) {
            uri = cardInfo.picUrl;
        } else {
            uri = cardInfo.grayPicUrl;
        }

        return (

            <JDImage
                imageStyle={ { resizeMode: 'stretch' } }
                style={ st.card_item }
                source={ { uri } }
            >

                <TouchableOpacity activeOpacity={ 1 } style={ st.movie_item } onPress={ this.cardClick }>

                    <View style={ st.item_top }>
                        <JDText style={ st.top_title }>{ cardInfo.name || (cardInfo.certType == 1 ? '贵宾兑换券' : cardInfo.certType == 3 ? '首映兑换券' : '电影兑换券')}</JDText>
                        <JDText style={ st.top_deadline }>有效期至{cardInfo.invalidTime}</JDText>
                    </View>

                    <View style={ st.item_bottom }>
                        {cardInfo.certType == 3 &&
                        <JDText
                            numberOfLines={ 1 }
                            style={ [st.bottom_movie, st.common_info] }>
                            限兑场次：电影首映场次
                        </JDText>
                        }

                        <JDText
                            numberOfLines={ 1 }
                            style={ [st.bottom_movie, st.common_info] }>
                            限兑影片：{cardInfo.movieNames ? cardInfo.movieNames : '不限'}
                        </JDText>

                        {!!cardInfo.movieCertRuleId &&
                            <JDText
                                numberOfLines={ 1 }
                                style={ [st.bottom_price, st.common_info] }
                            >
                                限兑影院：见详情列表
                            </JDText>
                        }

                        <JDText style={ [st.bottom_price, st.common_info] }>限兑金额：{cardInfo.quota / 100}元及以下</JDText>

                        <JDText style={ st.common_info }>剩余次数：{cardInfo.leftTimes}</JDText>
                    </View>

                    {
                        !!cardInfo.useNum &&
                            <View style={ st.bottom_rt }>
                                <View style={ st.bottom_rt_block }>
                                    <JDText style={ st.rt_info }>已选次数：{cardInfo.useNum}</JDText>
                                </View>
                                <View style={ st.bottom_rt_select }>
                                    <JDImage style={ st.select } source={ img.check } />
                                </View>
                            </View>
                    }

                </TouchableOpacity>

            </JDImage>

        );
    }

    cardClick() {
        const { cardClick, cardIndex, type } = this.props;

        if (!cardClick) {
            return;
        }

        cardClick(cardIndex, type);
    }
}

const img = {
    check: require('../../img/movie-card/check.png')
};

MovieCardItem.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    card_item: {
        marginBottom: pt(18),
        height: pt(151),
        width: pt(335)
    },
    movie_item: {
        flex: 1,
        justifyContent: 'space-between',
        paddingTop: pt(13),
        paddingHorizontal: pt(10),
        paddingBottom: pt(10),
        position: 'relative'
    },
    // 上部信息
    top_title: {
        marginBottom: pt(3),
        fontSize: pt(20),
        color: '#fff',
        backgroundColor: 'transparent'
    },
    top_deadline: {
        fontSize: pt(12),
        color: '#fff',
        backgroundColor: 'transparent'
    },
    // 下部信息
    bottom_price: {
        marginBottom: pt(1)
    },
    bottom_movie: {
        width: pt(200),
        marginBottom: pt(1)
    },
    common_info: {
        fontSize: pt(12),
        color: '#fff',
        backgroundColor: 'transparent'
    },
    // 选择次数
    bottom_rt: {
        flexDirection: 'row',
        alignItems: 'center',
        position: 'absolute',
        bottom: pt(10),
        right: pt(15)
    },
    bottom_rt_block: {
        marginRight: pt(7),
        paddingHorizontal: pt(10),
        paddingVertical: pt(5),
        borderRadius: pt(12),
        backgroundColor: '#fff'
    },
    rt_info: {
        fontSize: pt(11),
        color: '#3B20C6'
    },
    bottom_rt_select: {
        width: pt(30),
        height: pt(30),
        overflow: 'hidden',
        borderRadius: pt(15),
        backgroundColor: '#fff',
        justifyContent: 'center',
        alignItems: 'center'
    },
    select: {
        width: pt(16),
        height: pt(10)
    }
});
